import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import styles from './FilterDropdown.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import DatePicker from '../DatePicker/DatePicker';

function FilterDropdown({
  days,
  handleSetDays,
  setStartDate,
  setEndDate,
  variant,
  availableDays,
  hasCustom = true,
  startDate,
  endDate,
  allDataStart,
}) {
  const [toggle, setToggle] = useState(false);
  const [showDateModal, setShowDateModal] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setToggle(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const ISO_UTC_FMT = 'YYYY-MM-DD[T]HH:mm:ss[Z]';
  const handleSelect = (label) => {
    handleSetDays(label);
    setToggle(false);

    const now = moment();

    const startTodayLocal = now.clone().startOf('day');
    const endTodayLocal = now.clone().endOf('day');

    let startDateVal;
    let endDateVal;

    switch (label) {
      case 'Today': {
        startDateVal = startTodayLocal.clone().format(ISO_UTC_FMT);
        endDateVal = endTodayLocal.clone().format(ISO_UTC_FMT);
        break;
      }

      case 'Yesterday': {
        const startYesterdayLocal = startTodayLocal.clone().subtract(1, 'day');
        const endYesterdayLocal = startYesterdayLocal.clone().endOf('day');
        startDateVal = startYesterdayLocal.clone().format(ISO_UTC_FMT);
        endDateVal = endYesterdayLocal.clone().format(ISO_UTC_FMT);
        break;
      }

      case '7 Days': {
        const startLocal = startTodayLocal.clone().subtract(6, 'day');
        startDateVal = startLocal.clone().format(ISO_UTC_FMT);
        endDateVal = endTodayLocal.clone().format(ISO_UTC_FMT);
        break;
      }

      case '28 Days': {
        const startLocal = startTodayLocal.clone().subtract(27, 'day');
        startDateVal = startLocal.clone().format(ISO_UTC_FMT);
        endDateVal = endTodayLocal.clone().format(ISO_UTC_FMT);
        break;
      }

      case '90 Days': {
        const startLocal = startTodayLocal.clone().subtract(89, 'day');
        startDateVal = startLocal.clone().format(ISO_UTC_FMT);
        endDateVal = endTodayLocal.clone().format(ISO_UTC_FMT);
        break;
      }

      case 'All Data': {
        if (allDataStart) {
          const start = moment(allDataStart);
          startDateVal = start.subtract(1, 'day').clone().format(ISO_UTC_FMT);
          endDateVal = now.add(1, 'day').clone().format(ISO_UTC_FMT);
        } else {
          const fallbackStart = startTodayLocal.clone().subtract(89, 'day');
          startDateVal = fallbackStart.clone().format(ISO_UTC_FMT);
          endDateVal = endTodayLocal.clone().format(ISO_UTC_FMT);
        }
        break;
      }

      default:
        return;
    }

    setStartDate(startDateVal);
    setEndDate(endDateVal);
  };

  const handleToggleDropdown = () => {
    setToggle((prev) => !prev);

    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const dropdownWidth = 180;
      const screenWidth = window.innerWidth;
      let left = rect.right - buttonRef.current.offsetWidth + window.scrollX;

      if (left + dropdownWidth > screenWidth) {
        left = screenWidth - dropdownWidth - 10;
      }

      setDropdownPosition({
        top: rect.bottom + window.scrollY + 5,
        left,
      });
    }
  };

  let localDays = [
    'Today',
    'Yesterday',
    '7 Days',
    '28 Days',
    '90 Days',
    'All Data',
  ];
  if (availableDays) {
    localDays = availableDays;
  }

  return (
    <div className={`${styles['month-filter']} hide-on-export`} ref={buttonRef}>
      <div
        onClick={handleToggleDropdown}
        className={`${styles['month']} ${styles[variant]}`}
        type='button'
      >
        <SvgWithBranding type='calendar' />
        <p className={styles.text}>{days}</p>
        <SvgWithBranding type='arrow_down' className={styles.svg} />
      </div>

      {toggle &&
        ReactDOM.createPortal(
          <div
            ref={dropdownRef}
            className={styles['filter-dropdown']}
            style={{ top: dropdownPosition.top, left: dropdownPosition.left }}
          >
            {localDays.map((label) => (
              <a
                key={label}
                className={styles['filter-dropdown-item']}
                onClick={() => handleSelect(label)}
              >
                {label}
              </a>
            ))}
            {hasCustom ? (
              <a
                className={styles['filter-dropdown-item']}
                onClick={() => {
                  setShowDateModal(true);
                  setToggle(false);
                }}
              >
                Custom
              </a>
            ) : null}
          </div>,
          document.body,
        )}

      {showDateModal && (
        <DatePicker
          showDateModal={showDateModal}
          setShowDateModal={setShowDateModal}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          handleSubmitDatePicker={(s, e) => {
            const label = `${moment(s).format('DD/MM/YY')} - ${moment(e).format(
              'DD/MM/YY',
            )}`;
            handleSetDays(label);
          }}
        />
      )}
    </div>
  );
}

export default FilterDropdown;
